var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"relative px-4 inline-flex items-center justify-between type-scale-n1 focus:outline-none",class:[
    _vm.$style.root,
    _vm.$style[_vm.kind],
    _vm.$style[_vm.size],
    _vm.loading && 'pointer-events-none'
  ]},_vm.$listeners),[(_vm.loading)?_c('AppLoading'):[_vm._t("default"),(_vm.icon)?_c('i',{staticClass:"material-icons ml-4 type-scale-1"},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],_c('div',{class:_vm.$style.focusState})],2)}
var staticRenderFns = []

export { render, staticRenderFns }